export function usersOptions (state) {
  const users = state.users
  .filter(res => res.status === "Enabled")
  .map(res =>{
    let prefix = ""
    if(res.prefix){prefix = res.prefix.nameTh}
    return { label: prefix+res.name+" "+res.surname, value: res.id }
  })
  return users
}

